import { Tooltip } from "@octopusdeploy/design-system-components";
import { LicenseMessageDisposition, type LicenseLimitStatus } from "@octopusdeploy/octopus-server-client";
import React from "react";
import Card from "~/components/Card";
import { useOctopusTheme } from "~/components/Theme";
import styles from "./style.module.less";
interface UsageOverviewCardProps {
    licenseLimitStatus?: LicenseLimitStatus;
}
const TASK_CAP_TEXT = "Task Cap";
const MACHINE_TEXT = "Machines";
const MACHINE_DESCRIPTION = "Machines include active Linux Tentacles, Windows Tentacles, and SSH connection deployment targets.";
const MAX_VALUE = 2147483647;
export function UsageOverviewCard({ licenseLimitStatus }: UsageOverviewCardProps) {
    const theme = useOctopusTheme();
    if (!licenseLimitStatus)
        return null;
    const { LicensedLimit, CurrentUsage, Name, Disposition, Message } = licenseLimitStatus;
    const licensedLimitDisplay = LicensedLimit == MAX_VALUE ? "Unlimited" : LicensedLimit;
    const usageDisplay = Name === TASK_CAP_TEXT ? licensedLimitDisplay : `${CurrentUsage}/${licensedLimitDisplay}`;
    return (<Card className={styles.overviewItem} content={<>
                    <div className={styles.overviewCount}>
                        <span style={{ paddingRight: "0.5Rem" }}>{usageDisplay}</span>
                        {(Disposition === LicenseMessageDisposition.Warning || Disposition === LicenseMessageDisposition.Notice) && (<Tooltip content={Message}>
                                <em className={"fa-solid fa-triangle-exclamation"} style={{ color: theme.alertText }}/>
                            </Tooltip>)}
                        {Disposition === LicenseMessageDisposition.Error && (<Tooltip content={Message} position="bottom">
                                <em className={"fa-solid fa-exclamation-triangle"} style={{ color: theme.dangerText }}/>
                            </Tooltip>)}
                    </div>

                    <div className={styles.overviewDescription}>
                        <span style={{ paddingRight: "0.5Rem" }}>{Name}</span>
                        {Name === MACHINE_TEXT && (<Tooltip content={MACHINE_DESCRIPTION} position="bottom">
                                <em className={"fa-solid fa-circle-info"} style={{ color: theme.infoText }}/>
                            </Tooltip>)}
                    </div>
                </>} logo={<></>} header={""}/>);
}
